const strings: any = {
  ru: {
    auth: 'Авторизация',
    email: 'Email',
    password: 'Пароль',
    logOut: 'Выйти',
    invalidInput: 'Неправильный логин или пароль!',
    invalidInputField: 'Неверное поле!',
    reports: 'Отчеты',
    products: 'Продукты',
    product: 'Продукт',
    addProducts: 'Добавить продукт',
    added: 'Добавлено',
    allProducts: 'Все продукты',
    orders: 'Заказы',
    noItems: 'Пока ничего нет',
    level: 'Уровень',
    orderDescription: 'Описание заказа',
    userId: 'Id пользователя',
    price: 'Стоимость',
    name: 'Название',
    goods: 'Товары',
    newProduct: 'Новый продукт',
    categories: 'Категории',
    category: 'Категория',
    newCategory: 'Новая категория',
    add: 'Добавить',
    delete: 'Удалить',
    preview: 'Предпросмотр',
    view: 'Просмотр',
    photoUrl: 'Ссылка на фото',
    tags: 'Теги',
    newTag: 'Новый тег',
    pressEnterToApply: 'Нажмите Enter чтобы применить',
    done: 'Готово',
    next: 'Далее',
    edit: 'Изменить',
    quantity: 'Количество',
    homeDescription: 'В админ панеле вы можете управлять всеми аспектами магазина',
    addOrDeleteProducts: 'Добавлять или удалять товары',
    editProducts: 'Изменять товары',
    addOrDeleteCategories: 'Добавлять или удалять категории',
    editCategories: 'Изменять категории',
    seeReports: 'Смотреть статистику',
    seeOrders: 'Смотреть заказы',
    cancelOrders: 'Отменять заказы',
    deleteProductDescription: 'Удалить продукт?',
    cancel: 'Отмена',
    wait: 'Подождите пожалуйста...',
    language: 'Язык',
    monthsReport: 'Отчёт по месяцам',
    grid: 'Включить/выключить сетку',
    status: 'Статус',
    date: 'Дата',
    orderId: 'Номер заказа',
    photo: 'Фото',
    uploadPhoto: 'Загрузить фото',
    editStatus: 'Изменить статус',
    awaiting: 'Ожидает',
    delivering: 'Доставляется',
    delivered: 'Доставлен',
    refresh: 'Обновить',
    admins: 'Админы',
    adminId: 'Id админа',
    cannotEditSelf: 'Нельзя изменять себя',
    error: 'Ошибка',
    noPermission: 'Нет прав',
    UNDEFINED: 'UNDEFINED_WORD'
  },
  en: {
    auth: 'Authorization',
    email: 'Email',
    password: 'Password',
    logOut: 'Log out',
    invalidInput: 'Invalid login or password',
    invalidInputField: 'Invalid field!',
    reports: 'Reports',
    products: 'Products',
    product: 'Product',
    addProducts: 'Add product',
    allProducts: 'All products',
    orders: 'Orders',
    noItems: 'Nothing yet',
    level: 'Level',
    orderDescription: 'Order description',
    userId: 'User id',
    price: 'Price',
    name: 'Name',
    goods: 'Goods',
    newProduct: 'New product',
    added: 'Added',
    categories: 'Categories',
    category: 'Category',
    newCategory: 'New category',
    add: 'Add',
    delete: 'Delete',
    preview: 'Preview',
    view: 'View',
    photoUrl: 'Photo url',
    tags: 'Tags',
    newTag: 'New tag',
    pressEnterToApply: 'Press Enter to apply',
    done: 'Done',
    next: 'Next',
    edit: 'Edit',
    quantity: 'Quantity',
    homeDescription: 'In admin panel you can fully control your store',
    addOrDeleteProducts: 'Add or delete products',
    editProducts: 'Edit products',
    addOrDeleteCategories: 'Add or delete categories',
    editCategories: 'Edit categories',
    seeReports: 'See charts',
    seeOrders: 'See orders',
    cancelOrders: 'Cancel orders',
    deleteProductDescription: 'Delete product?',
    cancel: 'Cancel',
    wait: 'Wait please...',
    language: 'Language',
    monthsReport: 'Months reports',
    grid: 'On/Off grid',
    status: 'Status',
    date: 'Date',
    orderId: 'Order id',
    photo: 'Photo',
    uploadPhoto: 'Upload photo',
    editStatus: 'Edit status',
    awaiting: 'Awaiting',
    delivering: 'Delivering',
    delivered: 'Delivered',
    refresh: 'Refresh',
    admins: 'Admins',
    adminId: 'Admin id',
    cannotEditSelf: 'Cannot edit yourself',
    error: 'Error',
    noPermission: 'No permission',
    UNDEFINED: 'UNDEFINED_WORD'
  }
}

export function localization(word: string | 'UNDEFINED', language: string) {
  return strings[language][word];
}